import "@fontsource/roboto";
import "@fontsource/roboto-condensed";

import MySwiper from "./parts/MySwiperV2";
import Games from "./parts/Games";
import Content from "./parts/Content";
import { useEffect, useState } from "react";
import axios from "axios";

function Inicio({ flag }) {
  const [sectionToDisplay, setSectionToDisplay] = useState(null);

  const fetchData = () => {
    const endpoint = `${process.env.REACT_APP_SERVER}/mexico/fetch-setting`;

    axios
      .get(endpoint, {
        headers: JSON.parse(process.env.REACT_APP_SER_HEADER),
      })
      .then((res) => {
        // console.log(res.data);
        setSectionToDisplay(res.data.enablePromo);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="inicio">
      <MySwiper device={flag} />

      <div className="mh-20 pg">
        {sectionToDisplay !== null && (
          <Games device={flag} sectionToDisplay={sectionToDisplay} />
        )}
      </div>
      <Content />
    </div>
  );
}

export default Inicio;
